import React from 'react';
import { IComponentProps } from "../type";
import { useProps } from '@/pages/dashboard/components/PageContainer/Render/hooks';
import componentMap from '@/pages/dashboard/_config/compConfig';
import DefualtComponetCo from '../../DefualtComponetCo';

const Render = (props: IComponentProps) => {
  // 状态处理，接收data参数，组装config中的data，并向下传递
  const { data, changeData, config, logConfig, ...resetProps } = useProps(props);
  const { name, props: cprops, children, ...resetConf } = config || {};
  const componentName = name;

  if (!componentName) {
    return <DefualtComponetCo />;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention -- React 动态组件需 PascalCase
  const Component = componentMap[componentName];

  if (!Component) {
    return <DefualtComponetCo />;
  }

  return (
    <Component
      {...resetProps}
      {...resetConf}
      {...cprops}
      data={data}
      changeData={changeData}
      logConfig={logConfig}
    >
      {(children || [])?.map((item, index) => {
        return (
          <Render
            config={item}
            data={data}
            changeData={changeData}
            logConfig={logConfig}
            key={`${item.name}_${index}`}
          />
        );
      })}
    </Component>
  );
};

export default Render;
